module.exports = __webpack_public_path__ + "static/media/ruminate-screenshot1.8c0947e6.png";